//# sourceMappingURL=add.mjs.map
/// <reference types="./add.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function add() {
  return $svg.square(
    20,
    "<path d=\"M9.16663 9.16666V4.16666H10.8333V9.16666H15.8333V10.8333H10.8333V15.8333H9.16663V10.8333H4.16663V9.16666H9.16663Z\" fill=\"currentColor\"/>",
  );
}
